import { CandidateReferenceProspectDTO } from "@core/dto/candidate/candidate-reference/candidate-reference-prospect.dto";
import api from "@core/plugins/api";

const sendReferenceUrl = () => `/reference/finalize`;

export class CandidateReferenceService {
  static async sendReference({ prospect, token }) {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const dto = new CandidateReferenceProspectDTO(prospect);
      const referenceToSend = dto.prepareReferenceProspectData();
      return api.comet.post(sendReferenceUrl(), referenceToSend, config);
    } catch (error) {
      throw error;
    }
  }
}
